export const LOCAL_STORAGE_KEY = 'mage-cache-storage';
